import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getMessage } from '@gef-ui/localization/messages';

import TaskFlag from 'components/atoms/SvgrIcons/TaskFlag';
import fetch from 'features/common/fetch';
import { subheaders } from 'features/common/Subheader/constants';
import { getEscalationSummary } from 'features/views/dashboard/todaysUrgencies/selectors';
import { setContextUser } from 'features/views/userContext/actions';

import EscalationTemplate from './EscalationTemplate';

export const EscalationSummary = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const escalationSummary = useSelector(getEscalationSummary);
	const escalationIcon = <TaskFlag sx={{ color: 'warning.main', fontSize: 18, mr: 0.5 }} />;

	const handleRedirectToTasksOverview = useCallback(
		(user) => {
			dispatch(setContextUser(user));
			navigate({
				pathname: '/tasks',
			});
		},
		[dispatch, navigate],
	);

	return (
		<EscalationTemplate
			fetchStorePath={fetch.constants.urls.escalationSummary}
			icon={escalationIcon}
			subheaderId={subheaders.escalationSummary}
			text={getMessage('dashboard:todaysUrgencies.escalationSummary')}
			items={escalationSummary}
			onClickFn={handleRedirectToTasksOverview}
		/>
	);
};

export default EscalationSummary;
